import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { DocumentoTrazaService } from 'src/app/services/documento-traza.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-empresas-emitidos-detalle-historico',
  templateUrl: './detalle-historico.component.html',
  styleUrls: ['../empresas-emitidos.component.scss'],
  providers: [SecurityService],
})
export class EmpresasEmitidosDetalleHistoricoComponent implements OnInit {
  @ViewChild('detalleHistoricoDocumento', { static: true }) detalleHistoricoModal: ModalDirective;

  // Data & Tmp
  rutEmpresa: number;
  sucursalCodigo: number;
  loading: boolean = false;
  cabecera: any;
  listaMovimientos: Array<any> = [];
  listaMovimientosAll: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private documentoTrazaService: DocumentoTrazaService,
    public rutService: RutService
  ) {
    this.log = this.clog.log('EMPRESAS-EMITIDOS');
  }
  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.paginationContext.RecordsByPage = 10;
  }

  clearData() {
    this.cabecera = null;
    this.listaMovimientos = null;
    this.listaMovimientosAll = null;
    this.loading = true;

    this.paginationContext.CurrentPage = 1;
  }

  loadAndShow(doc) {
    this.clearData();

    const inputParams = {
      empresa_rut: this.rutEmpresa,
      tipo_dte_codigo: doc.tipo_dte_codigo,
      folio: Number(doc.folio),
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;

    this.detalleHistoricoModal.show();

    this.documentoTrazaService.obtenerDocumento(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { documento, eventos } = respuesta;

      this.cabecera = documento;
      this.cabecera.rut_emisorFormateado = this.rutService.AgregarDV(this.cabecera.rut_emisor);
      this.cabecera.rut_receptorFormateado = this.rutService.AgregarDV(this.cabecera.rut_receptor);

      // agregar a lista
      this.listaMovimientosAll = eventos;

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = 1;

      this.showPage(this.paginationContext.CurrentPage);
      this.loading = false;
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }
}
